import * as React from "react";

import {
  Autocomplete,
  Chip,
  Grid,
  TextField,
  TextFieldProps,
  UseAutocompleteProps,
} from "@mui/material";
import { axiosApi } from "../../../interceptors/axios";

interface MuAutocompleteProps<Value> {
  url: string;
  dataItemKey: string;
  dataTextValue: string;
  label: string;
  name?: string;
  onChange?: UseAutocompleteProps<Value, any, any, any>["onChange"];
}

export default function MuiAutocomplete<Value = any>(
  props: MuAutocompleteProps<Value> & Omit<TextFieldProps, "onChange">
) {
  const {
    dataItemKey,
    disabled,
    dataTextValue,
    url,
    fullWidth,
    defaultValue,
    value,
    name,
  } = props;

  const [options, setOptions] = React.useState<readonly Value[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setLoading(true);
    axiosApi
      .get(url)
      .then((result) => {
        setOptions(result.data.data);
      })
      .finally(() => setLoading(false));
  }, [url]);

  const handleChange = (event: any, newValue: any) => {
    setSelectedValue(newValue);
    if (props.onChange) {
      props.onChange(event, newValue, "selectOption", undefined);
    }
  };

  return (
    <>
      <Autocomplete
        sx={{ mb: 0.6 }}
        disabled={disabled}
        fullWidth={fullWidth}
        getOptionLabel={(option) => (option as any)[dataTextValue] || ""} // Type assertion eklendi
        isOptionEqualToValue={(option, value) => {
          if (typeof value === "object")
            return (option as any)[dataItemKey] === (value as any)[dataItemKey];
          return (option as any)[dataItemKey] === value;
        }}
        onChange={handleChange}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Grid sx={{ alignItems: "center" }}>
                {(option as any)[dataTextValue]}
              </Grid>
            </li>
          );
        }}
        renderInput={(params) => {
          return <TextField {...params} label={props.label} />;
        }}
        value={selectedValue}
        options={options}
        loading={loading}
      />
      {/* Hidden input for form submission */}
      {name && (
        <input
          type="hidden"
          name={name}
          value={
            typeof selectedValue === "object" && selectedValue
              ? (selectedValue as any)[dataItemKey]
              : selectedValue || ""
          }
        />
      )}
    </>
  );
}
